import { isAfter, subMinutes } from 'date-fns'

export interface IFeathersServiceStatus {
  name: string
  status: 'good' | 'bad'
  lastCheck: Date
  lastGood: Date
}

export class FeathersServiceStatus implements IFeathersServiceStatus {
  lastCheck: Date
  lastGood: Date
  name: string
  status: 'good' | 'bad'

  constructor(props: IFeathersServiceStatus) {
    this.name = props.name
    this.status = props.status
    this.lastCheck = new Date(props.lastCheck)
    this.lastGood = new Date(props.lastGood)
  }

  getStatus() {
    if (this.status === 'good') return true
    if (this.status === 'bad') return false
    return undefined
  }

  isGoodInLastTenMinutes() {
    if (this.status === 'bad') return false
    return isAfter(this.lastGood, subMinutes(new Date(), 10))
  }
}
